import Immutable from 'immutable';

const Company = Immutable.Record({
  id: null,
  name: null,
  history: true,
  avatarUrl: '',
  iconUrl: '',
  iconColor: '',
  greeting: '',
  enabled: false,
  useDefaultSchedule: false,
  activeForm: null,
  offhoursMessage: '',
  offhoursImageUrl: '',
  offhoursDisplay: '',
  hours: null,
  holidays: null,
  volumeControl: {},
  waitMessage: '',
  closableChat: false,
  singleSessionChat: false,
  showTypingIndicatorCustomerWeb: false,
  showTypingIndicatorWeb: false,
  showBrandingIdentifier: true,
  showEmailInputBanner: true,
});

export default Company;
